// @ts-nocheck

import React, { useEffect, useState } from 'react'
import Slider from 'react-slick'
import aroww from '../../../../../../../public/assets/img/WomansCategory/aroww.png'
import Frame1 from '../../../../../../../public/assets/img/WomansCategory/s1.png'
import Frame2 from '../../../../../../../public/assets/img/WomansCategory/s2.png'
import Frame3 from '../../../../../../../public/assets/img/WomansCategory/s3.png'
import Frame4 from '../../../../../../../public/assets/img/WomansCategory/s4.png'
import star from '../../../../../../../public/assets/img/WomansCategory/star.png'
import others from '../../../../../../../public/assets/img/WomansCategory/others.png'
import AllProduct from 'src/components/ProductPage/AllProduct'
import { useRouter } from 'next/router'
import { useSelector } from 'react-redux'
import { guestAccountDetailSlice } from 'src/store/slices/guestAccountDetailSlice'
import { useAppDispatch } from 'src/store/store'
import AosAnimation from 'src/utils/AosAnimation'
import { fetchProductByCategory } from 'src/store/slices/fetchAllProduct'
import { setStoreProductState } from 'src/store/slices/fetchAllStoresSlice'

export default function SubCategoryFindYourStyle(props) {
  const router = useRouter()
  const productByCategory = useSelector((state: any) => state?.productByCategory)
  const [filterData, setFilterData] = useState<any>({ subCategory: [], category: [] })
  const dispatch = useAppDispatch()
  const [page, setPage] = useState(1)
  const [dataLimite, setDataLimite] = useState(40)

  useEffect(() => {
    setPage(1)
    fetchProduct()
  }, [])

  const fetchProduct = () => {
    dispatch(
      fetchProductByCategory({
        category: 'fashion-and-accessories',
        subCategory: router?.asPath?.includes('women') ? 'women' : 'men',
        childSubCategory: router?.query?.category ? router?.query?.category : '',
        isShopifyProduct: false,
        page: page,
        limit: dataLimite,
      }),
    )
  }

  const fetchUpdatedProduct = (product_id, type) => {
    let update_product = []
    if (type === 'dislike') {
      update_product = productByCategory?.product?.getAllProducts?.data?.map((prd) => {
        if (prd?.id === product_id) {
          return {
            ...prd,
            likes: null,
          }
        } else {
          return prd
        }
      })
    } else if (type === 'like') {
      update_product = productByCategory?.product?.getAllProducts?.data?.map((prd) => {
        if (prd?.id === product_id) {
          return {
            ...prd,
            likes: {
              id: 3.3333,
            },
          }
        } else {
          return prd
        }
      })
    }
    dispatch(
      setStoreProductState({
        getAllProducts: {
          data: update_product,
        },
      }),
    )
    fetchProduct()
  }

  const Cards = [
    {
      img: null,
      type: null,
      parent_fill: true,
      child: [
        {
          img: Frame1,
          type: 'small',
        },
        {
          img: Frame2,
          type: 'small',
        },
      ],
    },
    {
      img: Frame4,
      type: 'large',
      parent_fill: false,
      child: [],
    },
    {
      img: null,
      type: null,
      parent_fill: true,
      child: [
        {
          img: Frame2,
          type: 'small',
        },
        {
          img: Frame1,
          type: 'small',
        },
      ],
    },
    {
      img: Frame4,
      type: 'large',
      parent_fill: false,
      child: [],
    },
    {
      img: Frame3,
      type: 'large',
      parent_fill: false,
      child: [],
    },
    {
      img: null,
      type: null,
      parent_fill: true,
      child: [
        {
          img: Frame1,
          type: 'small',
        },
        {
          img: Frame2,
          type: 'small',
        },
      ],
    },
  ]

  // const store = data?.getAllProducts?.data
  const { PageDataFun, menStyleData } = props
  const menStyleDetailModal = useSelector((state: any) => state?.manageCategoryDetail?.data)
  const [showbrandProduct, setShowBrandProduct] = useState(false)

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />,
  }

  function SampleNextArrow(props) {
    const { className, style, onClick } = props
    return (
      <div onClick={onClick} className="slider-right-arrow-alignment">
        <img src="/assets/icon/SliderRightArrow.svg" />
      </div>
    )
  }

  function SamplePrevArrow(props) {
    const { className, style, onClick } = props
    return (
      <div className="slider-left-arrow-alignment" onClick={onClick}>
        <img src="/assets/icon/SliderLeftArrow.svg" />
      </div>
    )
  }

  const handleBack = () => {
    if (menStyleData.flag) {
      PageDataFun('FindYourStyle')
    } else {
      PageDataFun('WomansCategory')
    }
  }

  const handleRedirect = () => {
    dispatch(
      guestAccountDetailSlice({
        modal: 'authModal',
        isOpen: true,
        id: {
          media: 'https://storage.googleapis.com/bluejestic-media/bluejestic-stage/loginmedia/Live-Shopping-Short.mp4',
          modalFor: 'login',
          startWith: 'loginModal',
        },
      }),
    )
  }

  return (
    <div className="casual-section">
      <div className="container">
        <div className="casual-banner">
          <div className="casual-banner-section">
            <div onClick={() => router.back()}>
              <img src="/assets/icon/leftArrow.svg" alt="left-arrow" />
            </div>
            <div className="casual-heading-alignment">
              <h4>{menStyleDetailModal?.id?.name}</h4>
              <p>Lorem ipsum dolor sit amet consectetur adipiscing elitr</p>
            </div>
          </div>
        </div>
      </div>
      {/* <div className="casual-fashion-section">
        <div className="container">
          <Slider {...settings}>
            {[0, 1, 2, 3, 4].map((_, index) => {
              return (
                <div
                  className="casual-fashion-details-alignment"
                  onMouseEnter={() => setShowBrandProduct(true)}
                  onMouseLeave={() => setShowBrandProduct(false)}
                  key={index}
                >
                  <div className="casual-fashion-flex-alignment">
                    <div
                      className={
                        showbrandProduct ? ' brand-hover-alignment fashion-store-alignment' : 'fashion-store-alignment'
                      }
                    >
                      <div>
                        <div className="log-alignment">
                          <img src="/assets/img/gucciLogo.png" alt="logo" />
                        </div>
                        <div className="fashion-shop-details-alignment">
                          <h2>GUCCI</h2>
                          <span>Fashion Store</span>
                        </div>
                        <div>
                          <div className="product">
                            <span>2.1k Followers </span>
                            <p></p>
                            <span> 543 Product</span>
                          </div>
                          <div className="Visitor">
                            <span className="mr-2">Today Visitor : 1.248</span>
                            <span className="pre">
                              <img src={aroww.src} alt="pre" /> <span className="ml-1">75%</span>
                            </span>
                          </div>
                        </div>
                        <div className="view-all-product-alignment">
                          <a>
                            Visit Store <img src="/assets/icon/right-blue-arrow.svg" />
                          </a>
                        </div>
                      </div>

                      <div className="product-all-brand-alignment">
                        <a>
                          See All Casual from Gucci <img src="/assets/icon/right-blue-arrow.svg" />
                        </a>
                      </div>
                    </div>
                    <div>
                      <div className="casual_product_block">
                        <div className="row casual_product_block_row ">
                          {Cards.map((Data, i) => {
                            return (
                              <React.Fragment key={i}>
                                {Data.parent_fill ? (
                                  <AosAnimation animationType="fade-up" duration={2500} delay={250}>
                                    <div key={`h${i + 1}`} className="card_col">
                                      <div className="cardcover">
                                        <div className="card_top">
                                          <img src={Data.child[0].img.src} alt="card_top_img" />
                                        </div>
                                        <div className="card_bottom">
                                          <div className="card_bottom_cover">
                                            <h4>Plain And Check Shirts</h4>
                                            <p className="amount">
                                              <span className="price">$245</span>
                                              <span className="orignal_price"> $ 425.00 </span>
                                              <span className="discount">40% OFF</span>
                                            </p>
                                            <p className="hike">
                                              <span className="inter">
                                                <img src={others.src} alt="hike" /> Interest
                                              </span>
                                              <span className="incris">
                                                <img src={aroww.src} alt="incris" /> 200%
                                              </span>
                                            </p>
                                            <div className="rating">
                                              <span className="rating_point">4.8</span>
                                              <div className="stars">
                                                <img src={star.src} alt="star" />
                                                <img src={star.src} alt="star" />
                                                <img src={star.src} alt="star" />
                                                <img src={star.src} alt="star" />
                                                <img src={star.src} alt="star" />
                                              </div>
                                              <span className="num">(437)</span>
                                            </div>
                                            <button className="buy_btn" onClick={handleRedirect}>
                                              Buy
                                            </button>
                                          </div>
                                        </div>
                                      </div>
                                      <div className="cardcover">
                                        <div className="card_top">
                                          <img src={Data.child[1].img.src} alt="card_top_img" />
                                        </div>
                                        <div className="card_bottom">
                                          <div className="card_bottom_cover">
                                            <h4>Plain And Check Shirts</h4>
                                            <p className="amount">
                                              <span className="price">$245</span>
                                              <span className="orignal_price"> $ 425.00 </span>
                                              <span className="discount">40% OFF</span>
                                            </p>
                                            <p className="hike">
                                              <span className="inter">
                                                <img src={others.src} alt="hike" /> Interest
                                              </span>
                                              <span className="incris">
                                                <img src={aroww.src} alt="incris" /> 200%
                                              </span>
                                            </p>
                                            <div className="rating">
                                              <span className="rating_point">4.8</span>
                                              <div className="stars">
                                                <img src={star.src} alt="star" />
                                                <img src={star.src} alt="star" />
                                                <img src={star.src} alt="star" />
                                                <img src={star.src} alt="star" />
                                                <img src={star.src} alt="star" />
                                              </div>
                                              <span className="num">(437)</span>
                                            </div>
                                            <button className="buy_btn" onClick={handleRedirect}>
                                              Buy
                                            </button>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </AosAnimation>
                                ) : (
                                  <AosAnimation animationType="fade-up" duration={3000} delay={350}>
                                    <div className="card_col">
                                      <div className="cardcover">
                                        <div className="card_top">
                                          <img src={Data.img.src} alt="card_top_img" />
                                        </div>
                                        <div className="card_bottom">
                                          <div className="card_bottom_cover">
                                            <h4>Plain And Check Shirts</h4>
                                            <p className="amount">
                                              <span className="price">$245</span>
                                              <span className="orignal_price"> $ 425.00 </span>
                                              <span className="discount">40% OFF</span>
                                            </p>
                                            <p className="hike">
                                              <span className="inter">
                                                <img src={others.src} alt="hike" /> Interest
                                              </span>
                                              <span className="incris">
                                                <img src={aroww.src} alt="incris" /> 200%
                                              </span>
                                            </p>
                                            <div className="rating">
                                              <span className="rating_point">4.8</span>
                                              <div className="stars">
                                                <img src={star.src} alt="star" />
                                                <img src={star.src} alt="star" />
                                                <img src={star.src} alt="star" />
                                                <img src={star.src} alt="star" />
                                                <img src={star.src} alt="star" />
                                              </div>
                                              <span className="num">(437)</span>
                                            </div>
                                            <button className="buy_btn" onClick={handleRedirect}>
                                              Buy
                                            </button>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </AosAnimation>
                                )}
                              </React.Fragment>
                            )
                          })}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )
            })}
          </Slider>
        </div>
      </div> */}
      <div className="store-page bg-white">
        <div className="feature-product-align">
          <div className="store-page-cover-info">
            <AllProduct
              products={productByCategory?.product?.getAllProducts?.data}
              storeId={0}
              color={'#FFFFFF'}
              isFilterMenu={true}
              total={productByCategory?.product?.getAllProducts?.total}
              isCalled={productByCategory?.called}
              dataLimite={dataLimite}
              setPage={setPage}
              APIcall={fetchUpdatedProduct}
              page={page}
              topForFilter={0}
              setFilterData={setFilterData}
              filterData={filterData}
              fetchUpdatedProduct={fetchUpdatedProduct}
            />
          </div>
        </div>
      </div>
    </div>
  )
}
